const compatibilidades = {
    Aries: {
        Aries: { amor: 75, comunicacion: 40, sexualidad: 85, objetivos: 60, ritmo: 90},
        Tauro: { amor: 30, comunicacion: 25, sexualidad: 45, objetivos: 20, ritmo: 15},
        Géminis: { amor: 85, comunicacion: 80, sexualidad: 90, objetivos: 75, ritmo: 90},
        Cáncer: { amor: 35, comunicacion: 25, sexualidad: 95, objetivos: 85, ritmo: 20},
        Leo: { amor: 90, comunicacion: 70, sexualidad: 95, objetivos: 85, ritmo: 95},
        Virgo: { amor: 25, comunicacion: 20, sexualidad: 40, objetivos: 30, ritmo: 25},
        Libra: { amor: 80, comunicacion: 75, sexualidad: 85, objetivos: 70, ritmo: 65},
        Escorpio: { amor: 70, comunicacion: 45, sexualidad: 90, objetivos: 55, ritmo: 70},
        Sagitario: { amor: 90, comunicacion: 85, sexualidad: 95, objetivos: 90, ritmo: 95},
        Capricornio: { amor: 30, comunicacion: 25, sexualidad: 45, objetivos: 40, ritmo: 20},
        Acuario: { amor: 80, comunicacion: 85, sexualidad: 80, objetivos: 85, ritmo: 90},
        Piscis: { amor: 50, comunicacion: 40, sexualidad: 60, objetivos: 45, ritmo: 55}
    },
    Tauro: {
        Aries: { amor: 30, comunicacion: 25, sexualidad: 45, objetivos: 20, ritmo: 15},
        Tauro: { amor: 65, comunicacion: 60, sexualidad: 70, objetivos: 80, ritmo: 75},
        Géminis: { amor: 30, comunicacion: 35, sexualidad: 80, objetivos: 95, ritmo: 80},
        Cáncer: { amor: 90, comunicacion: 85, sexualidad: 80, objetivos: 95, ritmo: 80},
        Leo: { amor: 60, comunicacion: 50, sexualidad: 70, objetivos: 55, ritmo: 45},
        Virgo: { amor: 85, comunicacion: 90, sexualidad: 80, objetivos: 95, ritmo: 90},
        Libra: { amor: 55, comunicacion: 50, sexualidad: 65, objetivos: 60, ritmo: 50},
        Escorpio: { amor: 85, comunicacion: 75, sexualidad: 95, objetivos: 80, ritmo: 70},
        Sagitario: { amor: 25, comunicacion: 20, sexualidad: 35, objetivos: 15, ritmo: 20},
        Capricornio: { amor: 90, comunicacion: 90, sexualidad: 85, objetivos: 95, ritmo: 90},
        Acuario: { amor: 20, comunicacion: 25, sexualidad: 30, objetivos: 15, ritmo: 25},
        Piscis: { amor: 90, comunicacion: 90, sexualidad: 85, objetivos: 85, ritmo: 80}
    },
    Géminis: {
        Aries: { amor: 85, comunicacion: 80, sexualidad: 90, objetivos: 75, ritmo: 90},
        Tauro: { amor: 30, comunicacion: 35, sexualidad: 80, objetivos: 95, ritmo: 80},
        Géminis: { amor: 65, comunicacion: 80, sexualidad: 70, objetivos: 50, ritmo: 75},
        Cáncer: { amor: 30, comunicacion: 25, sexualidad: 40, objetivos: 20, ritmo: 35},
        Leo: { amor: 90, comunicacion: 90, sexualidad: 85, objetivos: 80, ritmo: 90},
        Virgo: { amor: 50, comunicacion: 45, sexualidad: 55, objetivos: 60, ritmo: 50},
        Libra: { amor: 90, comunicacion: 95, sexualidad: 85, objetivos: 85, ritmo: 90},
        Escorpio: { amor: 25, comunicacion: 20, sexualidad: 50, objetivos: 30, ritmo: 35},
        Sagitario: { amor: 85, comunicacion: 90, sexualidad: 90, objetivos: 85, ritmo: 95},
        Capricornio: { amor: 20, comunicacion: 25, sexualidad: 30, objetivos: 20, ritmo: 30},
        Acuario: { amor: 90, comunicacion: 95, sexualidad: 80, objetivos: 90, ritmo: 90},
        Piscis: { amor: 50, comunicacion: 45, sexualidad: 55, objetivos: 40, ritmo: 60}
    },
    Cáncer: {
        Aries: { amor: 35, comunicacion: 25, sexualidad: 95, objetivos: 85, ritmo: 20},
        Tauro: { amor: 90, comunicacion: 85, sexualidad: 80, objetivos: 95, ritmo: 80},
        Géminis: { amor: 30, comunicacion: 25, sexualidad: 40, objetivos: 20, ritmo: 35},
        Cáncer: { amor: 70, comunicacion: 75, sexualidad: 65, objetivos: 80, ritmo: 70},
        Leo: { amor: 60, comunicacion: 50, sexualidad: 70, objetivos: 55, ritmo: 50},
        Virgo: { amor: 90, comunicacion: 90, sexualidad: 80, objetivos: 90, ritmo: 85},
        Libra: { amor: 30, comunicacion: 25, sexualidad: 40, objetivos: 35, ritmo: 40},
        Escorpio: { amor: 95, comunicacion: 90, sexualidad: 90, objetivos: 90, ritmo: 85},
        Sagitario: { amor: 25, comunicacion: 20, sexualidad: 40, objetivos: 15, ritmo: 25},
        Capricornio: { amor: 90, comunicacion: 85, sexualidad: 80, objetivos: 95, ritmo: 80},
        Acuario: { amor: 25, comunicacion: 20, sexualidad: 35, objetivos: 20, ritmo: 30},
        Piscis: { amor: 95, comunicacion: 95, sexualidad: 90, objetivos: 90, ritmo: 90}
    },
    Leo: {
        Aries: { amor: 90, comunicacion: 70, sexualidad: 95, objetivos: 85, ritmo: 95},
        Tauro: { amor: 60, comunicacion: 50, sexualidad: 70, objetivos: 55, ritmo: 45},
        Géminis: { amor: 90, comunicacion: 90, sexualidad: 85, objetivos: 80, ritmo: 90},
        Cáncer: { amor: 60, comunicacion: 50, sexualidad: 70, objetivos: 55, ritmo: 50},
        Leo: { amor: 75, comunicacion: 50, sexualidad: 85, objetivos: 70, ritmo: 80},
        Virgo: { amor: 30, comunicacion: 20, sexualidad: 45, objetivos: 35, ritmo: 40},
        Libra: { amor: 90, comunicacion: 85, sexualidad: 90, objetivos: 85, ritmo: 85},
        Escorpio: { amor: 60, comunicacion: 45, sexualidad: 80, objetivos: 55, ritmo: 65},
        Sagitario: { amor: 95, comunicacion: 90, sexualidad: 95, objetivos: 90, ritmo: 95},
        Capricornio: { amor: 55, comunicacion: 45, sexualidad: 65, objetivos: 60, ritmo: 50},
        Acuario: { amor: 40, comunicacion: 30, sexualidad: 55, objetivos: 35, ritmo: 45},
        Piscis: { amor: 55, comunicacion: 45, sexualidad: 60, objetivos: 50, ritmo: 55}
    },
    Virgo: {
        Aries: { amor: 25, comunicacion: 20, sexualidad: 40, objetivos: 30, ritmo: 25},
        Tauro: { amor: 85, comunicacion: 90, sexualidad: 80, objetivos: 95, ritmo: 90},
        Géminis: { amor: 50, comunicacion: 45, sexualidad: 55, objetivos: 60, ritmo: 50},
        Cáncer: { amor: 90, comunicacion: 90, sexualidad: 80, objetivos: 90, ritmo: 85},
        Leo: { amor: 30, comunicacion: 20, sexualidad: 45, objetivos: 35, ritmo: 40},
        Virgo: { amor: 60, comunicacion: 65, sexualidad: 55, objetivos: 75, ritmo: 70},
        Libra: { amor: 35, comunicacion: 30, sexualidad: 45, objetivos: 40, ritmo: 45},
        Escorpio: { amor: 85, comunicacion: 80, sexualidad: 85, objetivos: 90, ritmo: 80},
        Sagitario: { amor: 25, comunicacion: 20, sexualidad: 35, objetivos: 20, ritmo: 30},
        Capricornio: { amor: 95, comunicacion: 95, sexualidad: 85, objetivos: 95, ritmo: 90},
        Acuario: { amor: 25, comunicacion: 20, sexualidad: 30, objetivos: 25, ritmo: 35},
        Piscis: { amor: 60, comunicacion: 50, sexualidad: 65, objetivos: 55, ritmo: 50}
    },
    Libra: {
        Aries: { amor: 80, comunicacion: 75, sexualidad: 85, objetivos: 70, ritmo: 65},
        Tauro: { amor: 55, comunicacion: 50, sexualidad: 65, objetivos: 60, ritmo: 50},
        Géminis: { amor: 90, comunicacion: 95, sexualidad: 85, objetivos: 85, ritmo: 90},
        Cáncer: { amor: 30, comunicacion: 25, sexualidad: 40, objetivos: 35, ritmo: 40},
        Leo: { amor: 90, comunicacion: 85, sexualidad: 90, objetivos: 85, ritmo: 85},
        Virgo: { amor: 35, comunicacion: 30, sexualidad: 45, objetivos: 40, ritmo: 45},
        Libra: { amor: 70, comunicacion: 75, sexualidad: 70, objetivos: 80, ritmo: 70},
        Escorpio: { amor: 60, comunicacion: 50, sexualidad: 75, objetivos: 55, ritmo: 60},
        Sagitario: { amor: 90, comunicacion: 90, sexualidad: 85, objetivos: 85, ritmo: 90},
        Capricornio: { amor: 30, comunicacion: 25, sexualidad: 40, objetivos: 35, ritmo: 40},
        Acuario: { amor: 95, comunicacion: 95, sexualidad: 85, objetivos: 90, ritmo: 90},
        Piscis: { amor: 55, comunicacion: 50, sexualidad: 60, objetivos: 50, ritmo: 55}
    },
    Escorpio: {
        Aries: { amor: 70, comunicacion: 45, sexualidad: 90, objetivos: 55, ritmo: 70},
        Tauro: { amor: 85, comunicacion: 75, sexualidad: 95, objetivos: 80, ritmo: 70},
        Géminis: { amor: 25, comunicacion: 20, sexualidad: 50, objetivos: 30, ritmo: 35},
        Cáncer: { amor: 95, comunicacion: 90, sexualidad: 90, objetivos: 90, ritmo: 85},
        Leo: { amor: 60, comunicacion: 45, sexualidad: 80, objetivos: 55, ritmo: 65},
        Virgo: { amor: 85, comunicacion: 80, sexualidad: 85, objetivos: 90, ritmo: 80},
        Libra: { amor: 60, comunicacion: 50, sexualidad: 75, objetivos: 55, ritmo: 60},
        Escorpio: { amor: 75, comunicacion: 60, sexualidad: 95, objetivos: 70, ritmo: 80},
        Sagitario: { amor: 35, comunicacion: 25, sexualidad: 50, objetivos: 30, ritmo: 40},
        Capricornio: { amor: 90, comunicacion: 85, sexualidad: 90, objetivos: 95, ritmo: 85},
        Acuario: { amor: 30, comunicacion: 20, sexualidad: 45, objetivos: 25, ritmo: 35},
        Piscis: { amor: 95, comunicacion: 95, sexualidad: 95, objetivos: 90, ritmo: 90}
    },
    Sagitario: {
        Aries: { amor: 75, comunicacion: 40, sexualidad: 85, objetivos: 60, ritmo: 90},
        Tauro: { amor: 30, comunicacion: 25, sexualidad: 45, objetivos: 20, ritmo: 15},
        Géminis: { amor: 85, comunicacion: 90, sexualidad: 90, objetivos: 85, ritmo: 95},
        Cáncer: { amor: 25, comunicacion: 20, sexualidad: 40, objetivos: 15, ritmo: 25},
        Leo: { amor: 95, comunicacion: 90, sexualidad: 95, objetivos: 90, ritmo: 95},
        Virgo: { amor: 25, comunicacion: 20, sexualidad: 35, objetivos: 20, ritmo: 30},
        Libra: { amor: 90, comunicacion: 90, sexualidad: 85, objetivos: 85, ritmo: 90},
        Escorpio: { amor: 35, comunicacion: 25, sexualidad: 50, objetivos: 30, ritmo: 40},
        Sagitario: { amor: 70, comunicacion: 75, sexualidad: 80, objetivos: 70, ritmo: 85},
        Capricornio: { amor: 25, comunicacion: 20, sexualidad: 35, objetivos: 20, ritmo: 30},
        Acuario: { amor: 90, comunicacion: 90, sexualidad: 85, objetivos: 95, ritmo: 95},
        Piscis: { amor: 55, comunicacion: 45, sexualidad: 60, objetivos: 50, ritmo: 65}
    },
    Capricornio: {
        Aries: { amor: 30, comunicacion: 25, sexualidad: 45, objetivos: 40, ritmo: 20},
        Tauro: { amor: 90, comunicacion: 90, sexualidad: 85, objetivos: 95, ritmo: 90},
        Géminis: { amor: 20, comunicacion: 25, sexualidad: 30, objetivos: 20, ritmo: 30},
        Cáncer: { amor: 90, comunicacion: 85, sexualidad: 80, objetivos: 95, ritmo: 80},
        Leo: { amor: 55, comunicacion: 45, sexualidad: 65, objetivos: 60, ritmo: 50},
        Virgo: { amor: 95, comunicacion: 95, sexualidad: 85, objetivos: 95, ritmo: 90},
        Libra: { amor: 30, comunicacion: 25, sexualidad: 40, objetivos: 35, ritmo: 40},
        Escorpio: { amor: 90, comunicacion: 85, sexualidad: 90, objetivos: 95, ritmo: 85},
        Sagitario: { amor: 25, comunicacion: 20, sexualidad: 35, objetivos: 20, ritmo: 30},
        Capricornio: { amor: 70, comunicacion: 75, sexualidad: 65, objetivos: 85, ritmo: 80},
        Acuario: { amor: 25, comunicacion: 20, sexualidad: 30, objetivos: 20, ritmo: 30},
        Piscis: { amor: 90, comunicacion: 90, sexualidad: 85, objetivos: 90, ritmo: 85}
    },
    Acuario: {
        Aries: { amor: 80, comunicacion: 85, sexualidad: 80, objetivos: 85, ritmo: 90},
        Tauro: { amor: 20, comunicacion: 25, sexualidad: 30, objetivos: 15, ritmo: 25},
        Géminis: { amor: 90, comunicacion: 95, sexualidad: 80, objetivos: 90, ritmo: 90},
        Cáncer: { amor: 25, comunicacion: 20, sexualidad: 35, objetivos: 20, ritmo: 30},
        Leo: { amor: 40, comunicacion: 30, sexualidad: 55, objetivos: 35, ritmo: 45},
        Virgo: { amor: 25, comunicacion: 20, sexualidad: 30, objetivos: 25, ritmo: 35},
        Libra: { amor: 95, comunicacion: 95, sexualidad: 85, objetivos: 90, ritmo: 90},
        Escorpio: { amor: 30, comunicacion: 20, sexualidad: 45, objetivos: 25, ritmo: 35},
        Sagitario: { amor: 90, comunicacion: 90, sexualidad: 85, objetivos: 95, ritmo: 95},
        Capricornio: { amor: 25, comunicacion: 20, sexualidad: 30, objetivos: 20, ritmo: 30},
        Acuario: { amor: 65, comunicacion: 75, sexualidad: 60, objetivos: 80, ritmo: 75},
        Piscis: { amor: 55, comunicacion: 50, sexualidad: 60, objetivos: 50, ritmo: 60}
    },
    Piscis: {
        Aries: { amor: 50, comunicacion: 40, sexualidad: 60, objetivos: 45, ritmo: 55},
        Tauro: { amor: 90, comunicacion: 90, sexualidad: 85, objetivos: 85, ritmo: 80},
        Géminis: { amor: 50, comunicacion: 45, sexualidad: 55, objetivos: 40, ritmo: 60},
        Cáncer: { amor: 95, comunicacion: 95, sexualidad: 90, objetivos: 90, ritmo: 90},
        Leo: { amor: 55, comunicacion: 45, sexualidad: 60, objetivos: 50, ritmo: 55},
        Virgo: { amor: 60, comunicacion: 50, sexualidad: 65, objetivos: 55, ritmo: 50},
        Libra: { amor: 55, comunicacion: 50, sexualidad: 60, objetivos: 50, ritmo: 55},
        Escorpio: { amor: 95, comunicacion: 95, sexualidad: 95, objetivos: 90, ritmo: 90},
        Sagitario: { amor: 55, comunicacion: 45, sexualidad: 60, objetivos: 50, ritmo: 65},
        Capricornio: { amor: 90, comunicacion: 90, sexualidad: 85, objetivos: 90, ritmo: 85},
        Acuario: { amor: 55, comunicacion: 50, sexualidad: 60, objetivos: 50, ritmo: 60},
        Piscis: { amor: 75, comunicacion: 80, sexualidad: 70, objetivos: 70, ritmo: 75}
    }};

    export default compatibilidades;
